import { Book_1 } from './book1.js';
import { Book_2 } from './book2.js';
import { Book_3 } from './book3.js';
export * from './book1.js';
export * from './book2.js';
export * from './book3.js';
export const ListOf_Books = [
    Book_1,
    Book_2,
    Book_3
];
//# sourceMappingURL=index.js.map